// src/Pages/Cart/OrderPage.js

import React, { useState, useEffect } from "react";
import {
  collection,
  getDocs,
  addDoc,
  doc,
  updateDoc,
  arrayUnion,
  increment,
  writeBatch, // 🔑 Import writeBatch for efficient deletion
} from "firebase/firestore";
import { db } from "../../firebase";
import { FaCrown } from "react-icons/fa";
import { useLocation, useNavigate } from "react-router-dom";
import "./OrderPage.css";

// Your secret password for adding customers
const ADMIN_PASSWORD = "123456"; // ⚠️ IMPORTANT: In a real app, store this securely in an environment variable!

// ----------------------------------------------------------------------
// 🔑 NEW HELPER FUNCTION: WhatsApp Message Generator (NO CHANGE)
// ----------------------------------------------------------------------
const generateWhatsAppMessage = (orderId, finalOrder, customerPhone) => {
  const customerName = finalOrder.customerName;
  const orderDate = new Date(finalOrder.orderDate).toLocaleDateString("en-IN"); // Format product list

  const productLines = Object.values(finalOrder.products)
    .map((product) => {
      // Clean up empty fields for a cleaner message
      const weight = product.weight ? `Wt: ${product.weight}` : "";
      const length = product.length ? `Len: ${product.length}` : "";
      const delivery = product.deliveryDate
        ? `Del: ${product.deliveryDate}`
        : "";

      const details = [weight, length, delivery].filter(Boolean).join(", ");

      return `* ${product.productName}${details ? ` (${details})` : ""}`;
    })
    .join("\n");

  const commonDetails = finalOrder.commonDetails; // Build the message

  let message = `*✨ New Order Placed Successfully! (Internal Record) ✨*\n\n`;
  message += `*Customer:* ${customerName}\n`;
  message += `*Order ID:* ${orderId.substring(0, 6)}\n`;
  message += `*Date:* ${orderDate}\n\n`;

  message += `*--- Products ---\n*${productLines}\n\n`; // Advance/Common details

  const advanceAmount = finalOrder.commonDetails.advanceAmount || "0";
  const advanceGold = finalOrder.commonDetails.advanceGold || "0";

  message += `*--- Financials ---\n`;
  message += `*22K Rate:* ${commonDetails.rate22K || "N/A"}\n`;
  message += `*Advance (₹):* ${advanceAmount}\n`;
  message += `*Advance (Gold Cr):* ${advanceGold}\n`;

  if (commonDetails.labourType === "wastage") {
    message += `*Labour Type:* Wastage (${commonDetails.wastage || "0"}%)\n`;
  } else if (commonDetails.labourType === "rupee") {
    message += `*Labour Charge (₹):* ${commonDetails.labourCharge || "0"}\n`;
  } else {
    message += `*Labour Type:* Not Specified\n`;
  }

  message += `\nThank you!`; // Encode the message for the URL

  const encodedMessage = encodeURIComponent(message); // Clean the phone number (remove non-digits, assume international format works)

  const phone = customerPhone ? customerPhone.replace(/\D/g, "") : ""; // Construct the wa.me link

  return `https://wa.me/${phone}?text=${encodedMessage}`;
};

// ----------------------------------------------------------------------
// Existing CustomerSelect Component (NO CHANGE)
// ----------------------------------------------------------------------
const CustomerSelect = ({
  customers,
  selectedCustomer,
  onSelectCustomer,
  onAddNewCustomer,
}) => {
  const [searchQuery, setSearchQuery] = useState("");
  const [showDropdown, setShowDropdown] = useState(false);

  const filteredCustomers = customers.filter((customer) =>
    customer.name.toLowerCase().includes(searchQuery.toLowerCase())
  );

  const handleSelect = (customer) => {
    onSelectCustomer(customer);
    setSearchQuery(customer.name);
    setShowDropdown(false);
  };

  return (
    <div className="customer-select-container">
           {" "}
      <input
        type="text"
        placeholder="Search or add customer"
        value={searchQuery}
        onFocus={() => setShowDropdown(true)}
        onBlur={() => setTimeout(() => setShowDropdown(false), 200)}
        onChange={(e) => setSearchQuery(e.target.value)}
      />
           {" "}
      {showDropdown && (
        <ul className="customer-list">
                   {" "}
          <li className="add-new-option" onMouseDown={onAddNewCustomer}>
                        + Add New Customer          {" "}
          </li>
                   {" "}
          {filteredCustomers.map((customer) => (
            <li
              key={customer.id}
              onMouseDown={() => handleSelect(customer)}
              className={
                selectedCustomer && selectedCustomer.id === customer.id
                  ? "selected"
                  : ""
              }
            >
                            {customer.name}           {" "}
            </li>
          ))}
                 {" "}
        </ul>
      )}
         {" "}
    </div>
  );
};

// ----------------------------------------------------------------------
// Existing AddCustomerForm Component (NO CHANGE)
// ----------------------------------------------------------------------
const AddCustomerForm = ({ onAdd, onCancel }) => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [whatsapp, setWhatsapp] = useState("");
  const [password, setPassword] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    if (password !== ADMIN_PASSWORD) {
      alert("⚠️ Incorrect password. Please try again.");
      return;
    }
    onAdd({ name, email, mobile: phone, whatsapp });
  };

  return (
    <div className="modal-overlay">
           {" "}
      <div className="modal-content">
                <h3>Add New Customer</h3>       {" "}
        <form onSubmit={handleSubmit}>
                   {" "}
          <label>
                        Name:            {" "}
            <input
              type="text"
              value={name}
              onChange={(e) => setName(e.target.value)}
              required
            />
                     {" "}
          </label>
                   {" "}
          <label>
                        Email:            {" "}
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
                     {" "}
          </label>
                    {/* New div for side-by-side layout */}         {" "}
          <div className="contact-fields">
                       {" "}
            <label>
                            Phone No:              {" "}
              <input
                type="text"
                value={phone}
                onChange={(e) => setPhone(e.target.value)}
              />
                         {" "}
            </label>
                       {" "}
            <label>
                            WhatsApp No:              {" "}
              <input
                type="text"
                value={whatsapp}
                onChange={(e) => setWhatsapp(e.target.value)}
              />
                         {" "}
            </label>
                     {" "}
          </div>
                   {" "}
          <label>
                        Password:            {" "}
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
                     {" "}
          </label>
                   {" "}
          <div className="form-actions">
                       {" "}
            <button type="submit" className="save-btn">
                            Save Customer            {" "}
            </button>
                       {" "}
            <button type="button" onClick={onCancel} className="cancel-btn">
                            Cancel            {" "}
            </button>
                     {" "}
          </div>
                 {" "}
        </form>
             {" "}
      </div>
         {" "}
    </div>
  );
};

// ----------------------------------------------------------------------
// OrderPage Component
// ----------------------------------------------------------------------
const OrderPage = () => {
  const location = useLocation();
  const navigate = useNavigate(); // Get items from location state, ensuring it defaults to an empty array.

  const { itemsToOrder = [] } = location.state || {}; // 🔑 REFINED: products state initialized with itemsToOrder, or fallback demo data.

  const [products] = useState(
    itemsToOrder.length > 0
      ? itemsToOrder
      : [
          {
            id: "demo-1",
            name: "Elegant Gold Necklace",
            image: "https://via.placeholder.com/250x250?text=Necklace",
            length: "18 Inch",
            weight: "25 gm",
            productName: "Elegant Gold Necklace",
          },
          {
            id: "demo-2",
            name: "Silver Bracelet",
            image: "https://via.placeholder.com/250x250?text=Bracelet",
            length: "7 Inch",
            weight: "12 gm",
            productName: "Silver Bracelet",
          },
        ]
  );

  const [customers, setCustomers] = useState([]);
  const [selectedCustomer, setSelectedCustomer] = useState(null);
  const [orders, setOrders] = useState({});
  const [commonOrderDetails, setCommonOrderDetails] = useState({
    advanceAmount: "",
    advanceGold: "",
    labourType: "",
    labourCharge: "",
    wastage: "",
    rate22K: "",
  });
  const [showAddCustomerModal, setShowAddCustomerModal] = useState(false);

  useEffect(() => {
    if (products.length > 0) {
      const initialOrders = products.reduce((acc, item) => {
        acc[item.id] = {
          length: item.size || item.length || "",
          weight: item.weight || "",
          carat: item.carat || "",
          deliveryOption: "",
          deliveryDate: "",
        };
        return acc;
      }, {});
      setOrders(initialOrders);
    }
  }, [products]);

  useEffect(() => {
    const fetchCustomers = async () => {
      const querySnapshot = await getDocs(collection(db, "customers"));
      const list = querySnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      setCustomers(list);
    };
    fetchCustomers();
  }, []);

  const handleProductChange = (productId, field, value) => {
    setOrders((prev) => ({
      ...prev,
      [productId]: {
        ...prev[productId],
        [field]: value,
      },
    }));
  };

  const handleCommonChange = (field, value) => {
    setCommonOrderDetails((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const handleAddNewCustomer = () => {
    setShowAddCustomerModal(true);
  };

  const handleSaveNewCustomer = async (newCustomerData) => {
    try {
      const customerData = {
        ...newCustomerData,
        ongoingOrders: 0,
        balanceAmount: 0,
        balanceGold: 0,
        status: "Active",
        amountHistory: [],
        goldHistory: [],
      };
      const docRef = await addDoc(collection(db, "customers"), customerData);
      const customerWithId = { id: docRef.id, ...customerData };
      setCustomers((prev) => [...prev, customerWithId]);
      setSelectedCustomer(customerWithId);
      alert(`✅ Customer "${customerWithId.name}" added successfully!`);
      setShowAddCustomerModal(false);
    } catch (error) {
      console.error("❌ Error adding customer:", error);
      alert("❌ Failed to add customer. Please try again.");
    }
  }; // 🔑 CORE FUNCTION: handlePlaceOrder (The cart cleanup logic is verified here)

  const handlePlaceOrder = async () => {
    if (!selectedCustomer) {
      alert("Please select a customer before placing an order.");
      return;
    }

    try {
      const orderDate = new Date().toISOString(); // 1. Create the final products map (using original product ID as key)

      const finalProductsMap = products.reduce((acc, product) => {
        const orderData = orders[product.id] || {};
        acc[product.id] = {
          ...orderData,
          image: product.image,
          productName: product.productName,
        };
        return acc;
      }, {}); // 2. Separate advance amounts from common details

      const { advanceAmount, advanceGold, ...detailsForOrder } =
        commonOrderDetails;

      const advanceAmountValue = parseFloat(advanceAmount || 0);
      const advanceGoldValue = parseFloat(advanceGold || 0);

      const finalOrder = {
        customerId: selectedCustomer.id,
        customerName: selectedCustomer.name,
        commonDetails: detailsForOrder,
        products: finalProductsMap,
        orderDate: orderDate,
        status: "Ongoing",
      }; // 3. Add the order to the "orders" collection

      const orderDocRef = await addDoc(collection(db, "orders"), finalOrder); // 4. Update customer's document

      const customerRef = doc(db, "customers", selectedCustomer.id);
      const customerUpdates = {
        ongoingOrders: increment(1),
      };

      if (advanceAmountValue > 0) {
        customerUpdates.balanceAmount = increment(advanceAmountValue);
        customerUpdates.amountHistory = arrayUnion({
          date: orderDate,
          amount: advanceAmountValue,
          orderId: orderDocRef.id.substring(0, 6),
          type: "Credit",
        });
      }

      if (advanceGoldValue > 0) {
        customerUpdates.balanceGold = increment(advanceGoldValue);
        customerUpdates.goldHistory = arrayUnion({
          date: orderDate,
          gold: advanceGoldValue,
          orderId: orderDocRef.id.substring(0, 6),
          type: "Credit",
        });
      }

      await updateDoc(customerRef, customerUpdates); // 🔑 5. CART CLEANUP: Delete items from the "carts" collection // This logic correctly filters out demo items and deletes real cart items.

      const cartItemsToDelete = products.filter(
        (
          item // Only process items that originated from the Firestore cart
        ) => !item.id.startsWith("demo-")
      );

      if (cartItemsToDelete.length > 0) {
        const batch = writeBatch(db);
        cartItemsToDelete.forEach((item) => {
          // item.id here is the Firestore document ID from the 'carts' collection
          const cartDocRef = doc(db, "carts", item.id);
          batch.delete(cartDocRef);
        });

        await batch.commit();
        console.log(
          `✅ Successfully cleared ${cartItemsToDelete.length} items from cart in Firestore.`
        );
      }

      alert(
        "Order placed successfully, customer record updated, and cart cleared!"
      ); // 🔑 6. WHATSAPP NOTIFICATION: Send order details to the customer (NO CHANGE)

      const customerPhone =
        selectedCustomer.whatsapp || selectedCustomer.mobile;
      if (customerPhone) {
        const whatsappUrl = generateWhatsAppMessage(
          orderDocRef.id,
          finalOrder,
          customerPhone
        ); // Open WhatsApp in a new tab/window
        window.open(whatsappUrl, "_blank");
      } else {
        console.log(
          "Customer phone not available for automatic WhatsApp send."
        );
        alert(
          "Order placed! Please manually share the details with the customer as their WhatsApp number is missing."
        );
      } // 7. Redirect to a success page

      navigate("/order-success", {
        state: { order: finalOrder, orderId: orderDocRef.id },
      }); // Reset form fields after successful submission

      setOrders({});
      setCommonOrderDetails({
        advanceAmount: "",
        advanceGold: "",
        labourType: "",
        labourCharge: "",
        wastage: "",
        rate22K: "",
      });
      setSelectedCustomer(null);
    } catch (error) {
      console.error("❌ Error placing order or updating customer:", error);
      alert("❌ Failed to place order. Please try again.");
    }
  };

  return (
    <div className="order-page">
            {/* Banner */}     {" "}
      <section className="order-banner">
                <FaCrown className="banner-icon" />       {" "}
        <h1>Premium Order</h1>       {" "}
        <p>Customize and place your elegant jewellery orders.</p>     {" "}
      </section>
            {/* Common Details Section */}     {" "}
      <section className="common-details-section">
                <h2>Order Details</h2>       {" "}
        <label>
                    Select Customer:          {" "}
          <CustomerSelect
            customers={customers}
            selectedCustomer={selectedCustomer}
            onSelectCustomer={setSelectedCustomer}
            onAddNewCustomer={handleAddNewCustomer}
          />
                 {" "}
        </label>
               {" "}
        <label>
                    22K Rate:          {" "}
          <input
            type="number"
            placeholder="e.g. 5500"
            value={commonOrderDetails.rate22K}
            onChange={(e) => handleCommonChange("rate22K", e.target.value)}
          />
                 {" "}
        </label>
               {" "}
        <label>
                    Advance Amount:          {" "}
          <input
            type="number"
            placeholder="₹ 0"
            value={commonOrderDetails.advanceAmount}
            onChange={(e) =>
              handleCommonChange("advanceAmount", e.target.value)
            }
          />
                 {" "}
        </label>
               {" "}
        <label>
                    Advance Gold Cr:          {" "}
          <input
            type="number"
            placeholder="e.g. 10 gm"
            value={commonOrderDetails.advanceGold}
            onChange={(e) => handleCommonChange("advanceGold", e.target.value)}
          />
                 {" "}
        </label>
               {" "}
        <label>
                    Labour Charges Type:          {" "}
          <select
            value={commonOrderDetails.labourType}
            onChange={(e) => handleCommonChange("labourType", e.target.value)}
          >
                        <option value="">Select</option>           {" "}
            <option value="wastage">Wastage (%)</option>           {" "}
            <option value="rupee">Rupee (₹)</option>         {" "}
          </select>
                 {" "}
        </label>
               {" "}
        {commonOrderDetails.labourType === "wastage" && (
          <label>
                        Wastage %:            {" "}
            <input
              type="number"
              placeholder="e.g. 5%"
              value={commonOrderDetails.wastage}
              onChange={(e) => handleCommonChange("wastage", e.target.value)}
            />
                     {" "}
          </label>
        )}
               {" "}
        {commonOrderDetails.labourType === "rupee" && (
          <label>
                        Labour Charges (₹):            {" "}
            <input
              type="number"
              placeholder="e.g. 2000"
              value={commonOrderDetails.labourCharge}
              onChange={(e) =>
                handleCommonChange("labourCharge", e.target.value)
              }
            />
                     {" "}
          </label>
        )}
             {" "}
      </section>
            {/* Product Order Cards */}     {" "}
      <section className="order-cards">
               {" "}
        {products.map((product) => {
          const productData = orders[product.id] || {};
          return (
            <div className="order-card" key={product.id}>
                            {/* Left - Image */}             {" "}
              <div className="product-image">
                               {" "}
                <img src={product.image} alt={product.productName} />           
                 {" "}
              </div>
                            {/* Right - Form */}             {" "}
              <div className="order-form">
                                <h3>{product.productName}</h3>               {" "}
                <label>
                                    Length:                  {" "}
                  <input
                    type="text"
                    placeholder={product.length || "e.g. 18 Inch"}
                    value={productData.length || ""}
                    onChange={(e) =>
                      handleProductChange(product.id, "length", e.target.value)
                    }
                  />
                                 {" "}
                </label>
                               {" "}
                <label>
                                    Weight:                  {" "}
                  <input
                    type="text"
                    placeholder={product.weight || "e.g. 25 gm"}
                    value={productData.weight || ""}
                    onChange={(e) =>
                      handleProductChange(product.id, "weight", e.target.value)
                    }
                  />
                                 {" "}
                </label>
                                {/* Add Delivery Date Input */}               {" "}
                <label>
                                    Delivery Date:                  {" "}
                  <input
                    type="date"
                    value={productData.deliveryDate || ""}
                    onChange={(e) =>
                      handleProductChange(
                        product.id,
                        "deliveryDate",
                        e.target.value
                      )
                    }
                  />
                                 {" "}
                </label>
                             {" "}
              </div>
                         {" "}
            </div>
          );
        })}
             {" "}
      </section>
            {/* Place Order Button */}     {" "}
      <div className="order-footer">
               {" "}
        <button className="place-order-btn" onClick={handlePlaceOrder}>
                    Place Order        {" "}
        </button>
             {" "}
      </div>
            {/* Add Customer Modal/Popup */}     {" "}
      {showAddCustomerModal && (
        <AddCustomerForm
          onAdd={handleSaveNewCustomer}
          onCancel={() => setShowAddCustomerModal(false)}
        />
      )}
         {" "}
    </div>
  );
};

export default OrderPage;
